export const NA = 'NA';
export const PASS = 'PASS';
export const FAIL = 'FAIL';
export const INDETERMINATE = 'INDETERMINATE';


// WEBPACK FOOTER //
// ./src/constants/testCaseResultTypes.js